import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { UpdateFeatureFlagRequest } from '@/definitions/featureFlags'
import { UpdateFeatureFlag } from '@/services/FeatureFlagService'

interface UpdateFeatureFlagVariables {
  name: string
  data: UpdateFeatureFlagRequest
}

export const useUpdateFeatureFlag = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ name, data }: UpdateFeatureFlagVariables) => UpdateFeatureFlag(name, data),
    // The switches form reports a failure next to the switches that failed, which
    // a generic toast cannot do.
    meta: { suppressGlobalError: true },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['feature-flags'] })
      // A global switch changes what every organization's tab shows, and there is
      // no way to know which are cached.
      queryClient.invalidateQueries({ queryKey: ['org-feature-flags'] })
    },
  })
}
